export default "__VITE_ASSET__DXNVAK1G__"